/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export const DIALOGUE_OK = 'Delete Machine';
export const DIALOGUE_CANCEL = 'Cancel';
export const DIALOGUE_CONTENT = 'Delete Machine?';
export const ROTATE_SECRET_CONTENT = 'Rotate Client Secret';
export const EMPTY_SCREEN_TEXT = 'Create first Machine';
export const EMPTY_SCREEN_TITLE = 'Machines are client IDs that are associated with roles.';
export const UBER = 'Uber';
export const UBER_REALM_CLIENT_TOOLTIP = 'Uber realm client';
export const ROWS_PER_PAGE_LABEL = 'Rows per page:';
export const MACHINE_TYPES = {
    "apim": "API",
    "sf":"Snowflake",
    "EFS": "Event"
};